<template>
  <v-container>
    <v-data-iterator :items="items" :loading="!'next' in items" disable-pagination :search="search" hide-default-footer>
      <template v-slot:header>
        <toolbar :mode="mode" view="list" :icon="icon" :title="`${capitalize(pluralize(mode))}`" small />
      </template>
      <template v-slot:default="props">
        <v-data-iterator :items="props.items" item-key="name" hide-default-footer>
          <template v-slot:default="{ items }">
            <v-row>
              <v-col v-for="(item, index) in items" :key="index" :cols="cols">
                <v-card :color="cardColor(item)" :dark="cardColor(item) == 'red'" :to="path(item)" class="d-flex flex-column fill-height " flat>
                  <div class="d-flex align-center">
                    <v-avatar class="d-none d-xl-flex ma-4 me-0" size="64" tile v-if="['application','agent'].includes(mode)">
                      <v-icon size="64">{{ cardIcon }}</v-icon>
                    </v-avatar>
                    <div>
                      <v-card-title>
                        {{ item.name }}
                      </v-card-title>
                      <v-card-subtitle>
                        <template v-if="mode == 'file'">
                          <template v-if="'file' in item">{{ item.file.name }}</template>
                          <template v-else>&mdash; missing &mdash;</template>
                        </template>
                        <template v-if="mode == 'dataset'">
                          {{ item.completion.name }}
                          <template v-if="item.production">/ {{ item.production.name }}</template>
                        </template>
                        <template v-if="mode == 'prediction'">{{ item.application.name }} / {{ item.dataset.name }}</template>
                        <template v-if="['application','agent'].includes(mode)">
                          {{ item.description }}
                        </template>
                      </v-card-subtitle>
                      <v-spacer />
                      <v-card-text v-if="!['application','agent'].includes(mode)">
                        <v-spacer />
                        <v-icon class="mr-2" v-if="item.owner.name != $store.state.user.name">mdi-account-multiple</v-icon>
                        <span class="text-caption">{{ item.updated_at | dateFormat }}</span>
                      </v-card-text>
                    </div>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </template>
        </v-data-iterator>
      </template>
      <template v-slot:no-data>
        <v-card color="transparent" dark flat><v-card-text>
          No data available
        </v-card-text></v-card>
      </template>
    </v-data-iterator>
  </v-container>
</template>
<script>
import toolbar from "@/components/toolbar"
import AxButton from "@/components/button"
import AxToggle from "@/components/toggle"
export default {
  name: "Grid",
  components: {
    toolbar,
    AxButton,
    AxToggle
  },
  props: {
    items: { type: Array, required: true },
    mode: { type: String, required: true },
    cols: { type: Number, default: 4 }
  },
  data() {
    return {
      search: "",
    }
  },
  computed: {
    icon() {
      if (this.mode == "file") return "mdi-file-document"
      if (this.mode == "dataset") return "mdi-database"
      if (this.mode == "prediction") return "mdi-finance"
      if (this.mode == "agent") return "mdi-run-fast"
      return "mdi-cog"
    },
    show() {
      if (this.mode == "file") return "fileShow"
      if (this.mode == "dataset") return "datasetShow"
      if (this.mode == "prediction") return "predictionShow"
      if (this.mode == "application") return "applicationShow"
      if (this.mode == "agent") return "agentShow"
      if (this.mode == "task") return "taskShow"
    },
    cardIcon() {
      if (this.mode == 'agent') return 'mdi-run-fast'
      if (this.mode == 'application') return 'mdi-cog'
      return "mdi-help-circle"
    }
  },
  methods: {
    path(item) {
      if (["application","agent"].includes(this.mode)) {
        return { name: this.show, params: { slug: item.slug } }
      } else {
        return { name: this.show, params: { uuid: item.uuid } }
      }
    },
    cardColor(item) {
      if (["FAILURE", "REVOKED"].includes(item.status)) return "red"
      if (["STARTED", "PENDING"].includes(item.status)) return "amber"
      return null
    },
  }
}
</script>